var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectCategoryInnovation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 36983"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 254",
    d: "M17 10L7 1",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 257",
    d: "M12.6641 17.3701L1.66406 7.37012",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 255",
    d: "M6.2959 5.7998L1.00001 1.00039",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 256",
    d: "M12.915 12.1084L7.66549 7.37081",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 258",
    d: "M3 15V17",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 260",
    d: "M23 7V9",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 259",
    d: "M4 16L2 16",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 261",
    d: "M24 8L22 8",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 590",
    cx: 20.5,
    cy: 2.5,
    r: 0.75,
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 591",
    cx: 16.5,
    cy: 5.5,
    r: 0.75,
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 592",
    cx: 24.5,
    cy: 17.5,
    r: 0.75,
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 90",
    d: "M18.1857 10.9642L18.9497 12.8743C18.9801 12.9502 19.0536 13 19.1354 13H21.5172C21.6953 13 21.7846 13.2154 21.6586 13.3414L20.0728 14.9272C20.0271 14.9729 20.0063 15.0378 20.0169 15.1015L20.4288 17.5728C20.4568 17.7411 20.2749 17.8649 20.1286 17.7772L18.1029 16.5617C18.0396 16.5237 17.9604 16.5237 17.8971 16.5617L15.8714 17.7772C15.7251 17.8649 15.5432 17.7411 15.5712 17.5728L15.9831 15.1015C15.9937 15.0378 15.9729 14.9729 15.9272 14.9272L14.3414 13.3414C14.2154 13.2154 14.3047 13 14.4828 13H16.8646C16.9464 13 17.0199 12.9502 17.0503 12.8743L17.8143 10.9642C17.8814 10.7966 18.1186 10.7966 18.1857 10.9642Z",
    stroke: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCategoryInnovation);
export default __webpack_public_path__ + "static/media/project-category-innovation.6d3a0285.svg";
export { ForwardRef as ReactComponent };